import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.touchStart = 0
    this.touchEnd = 0
    this.currentIndex = 0
    this.slides = this.element.querySelectorAll('.gallery__slide')
    this.createDots()
    this.bindEvents()
  }

  createDots() {
    const dotsContainer = this.element.querySelector('.gallery__dots')
    this.slides.forEach((_, index) => {
      const dot = document.createElement('div')
      dot.classList.add('gallery__dot')
      if (index === 0) dot.classList.add('gallery__dot--active')
      dotsContainer.appendChild(dot)
    })
  }

  bindEvents() {
    this.element.addEventListener('touchstart', e => this.handleTouchStart(e))
    this.element.addEventListener('touchmove', e => this.handleTouchMove(e))
    this.element.addEventListener('touchend', () => this.handleTouchEnd())
    document.addEventListener('keydown', e => this.handleKeydown(e))
    this.slides.forEach(slide => {
      slide.addEventListener('click', () => this.showFullscreen(slide))
    })
  }

  handleTouchStart(e) {
    this.touchStart = e.touches[0].clientX
  }

  handleTouchMove(e) {
    this.touchEnd = e.touches[0].clientX
  }

  handleTouchEnd() {
    const swipeDistance = this.touchStart - this.touchEnd
    if (Math.abs(swipeDistance) > 50) {
      if (swipeDistance > 0 && this.currentIndex < this.slides.length - 1) {
        this.currentIndex++
      } else if (swipeDistance < 0 && this.currentIndex > 0) {
        this.currentIndex--
      }
      this.updateGallery()
    }
  }

  updateGallery() {
    const container = this.element.querySelector('.gallery__container')
    container.style.transform = `translateX(-${this.currentIndex * 100}%)`
    
    const dots = this.element.querySelectorAll('.gallery__dot')
    dots.forEach((dot, index) => {
      dot.classList.toggle('gallery__dot--active', index === this.currentIndex)
    })
  }

  handleKeydown(e) {
    if (e.key === 'ArrowRight' && this.currentIndex < this.slides.length - 1) {
      this.currentIndex++
      this.updateGallery()
    } else if (e.key === 'ArrowLeft' && this.currentIndex > 0) {
      this.currentIndex--
      this.updateGallery()
    }
  }

  showFullscreen(slide) {
    const fullscreenContainer = document.createElement('div')
    fullscreenContainer.classList.add('gallery__fullscreen')
    
    const originalImg = slide.querySelector('img')
    const image = originalImg.cloneNode(true)
    image.src = originalImg.currentSrc || originalImg.src || originalImg.getAttribute('data-src')
    fullscreenContainer.appendChild(image)
    
    const prevButton = document.createElement('button')
    prevButton.innerHTML = '‹'
    prevButton.classList.add('gallery__fullscreen-nav', 'gallery__fullscreen-prev')
    fullscreenContainer.appendChild(prevButton)

    const nextButton = document.createElement('button')
    nextButton.innerHTML = '›'
    nextButton.classList.add('gallery__fullscreen-nav', 'gallery__fullscreen-next')
    fullscreenContainer.appendChild(nextButton)
    
    const closeButton = document.createElement('button')
    closeButton.innerHTML = '×'
    closeButton.classList.add('gallery__fullscreen-close')
    fullscreenContainer.appendChild(closeButton)
    
    const navigateFullscreen = (direction) => {
      this.currentIndex = (this.currentIndex + direction + this.slides.length) % this.slides.length
      const originalImg = this.slides[this.currentIndex].querySelector('img')
      const newSrc = originalImg.currentSrc || originalImg.src || originalImg.getAttribute('data-src')
      const fullscreenImg = document.querySelector('.gallery__fullscreen img')
      if (fullscreenImg) {
        fullscreenImg.src = newSrc
      }
      this.updateGallery()
    }

    prevButton.addEventListener('click', () => navigateFullscreen(-1))
    nextButton.addEventListener('click', () => navigateFullscreen(1))
    
    const handleFullscreenKeydown = (e) => {
      if (e.key === 'ArrowRight') navigateFullscreen(1)
      if (e.key === 'ArrowLeft') navigateFullscreen(-1)
      if (e.key === 'Escape') document.body.removeChild(fullscreenContainer)
    }
    document.addEventListener('keydown', handleFullscreenKeydown)
    
    let touchStartX = 0
    let touchEndX = 0

    fullscreenContainer.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX
    })

    fullscreenContainer.addEventListener('touchmove', (e) => {
      touchEndX = e.touches[0].clientX
    })

    fullscreenContainer.addEventListener('touchend', () => {
      const swipeDistance = touchStartX - touchEndX
      if (Math.abs(swipeDistance) > 50) {
        if (swipeDistance > 0) {
          navigateFullscreen(1)  // Swipe left -> next image
        } else {
          navigateFullscreen(-1) // Swipe right -> previous image
        }
      }
    })
    
    fullscreenContainer.addEventListener('click', (e) => {
      if (
        (e.target === fullscreenContainer || e.target === closeButton) && 
        touchStartX === touchEndX &&
        e.target !== prevButton &&
        e.target !== nextButton
      ) {
        document.body.removeChild(fullscreenContainer)
        document.removeEventListener('keydown', handleFullscreenKeydown)
      }
    })
    
    closeButton.addEventListener('click', () => {
      document.body.removeChild(fullscreenContainer)
      document.removeEventListener('keydown', handleFullscreenKeydown)
    })
    
    document.body.appendChild(fullscreenContainer)
  }
}